(function(w, d, t, h, s, n) {
  w.FlodeskObject = n;
  var fn = function() {
    (w[n].q = w[n].q || []).push(arguments);
  };
  w[n] = w[n] || fn;
  var f = d.getElementsByTagName(t)[0];
  var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
  var sm = d.createElement(t);
  sm.async = true;
  sm.type = 'module';
  sm.src = h + s + '.mjs' + v;
  f.parentNode.insertBefore(sm, f);
  var sn = d.createElement(t);
  sn.async = true;
  sn.noModule = true;
  sn.src = h + s + '.js' + v;
  f.parentNode.insertBefore(sn, f);
})(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

document.addEventListener('click', function (event) {
  var openTrigger = event.target.closest('[data-flodesk-open]');
  if (openTrigger) {
    event.preventDefault();
    event.stopPropagation();
    var popup = document.getElementById(openTrigger.getAttribute('data-flodesk-open'));
    if (popup) openFlodeskPopup(popup);
    return;
  }
  var closeTrigger = event.target.closest('[data-flodesk-close]');
  if (closeTrigger) {
    event.preventDefault();
    event.stopPropagation();
    var popup = closeTrigger.closest('.flodesk-popup');
    if (popup) closeFlodeskPopup(popup);
  }
}, true);

function isQuickViewOpen() {
  try {
    return !!(window.Alpine
      && Alpine.store('modals')
      && Alpine.store('modals').quickViewDrawer
      && Alpine.store('modals').quickViewDrawer.open);
  } catch (e) {
    return false;
  }
}

function openFlodeskPopup(popup) {
  var nested = isQuickViewOpen();
  var targetParent = document.body;

  if (nested) {
    var trapRoot = document.getElementById('quick-view-drawer-slot');
    if (trapRoot) {
      targetParent = trapRoot;
    } else {
      nested = false;
    }
  }

  if (popup.parentElement !== targetParent) {
    targetParent.appendChild(popup);
  }

  popup.classList.toggle('flodesk-popup--nested', nested);

  var formId = popup.getAttribute('data-flodesk-form-id');
  var container = popup.querySelector('.flodesk-popup__form-container');
  if (formId && container && !container.dataset.rendered) {
    window.fd('form', { formId: formId, containerEl: '#' + container.id });
    container.dataset.rendered = 'true';
  }
  popup.removeAttribute('hidden');

  if (!nested) {
    document.body.style.overflow = 'hidden';
  }
}

function closeFlodeskPopup(popup) {
  popup.setAttribute('hidden', '');
  var wasNested = popup.classList.contains('flodesk-popup--nested');
  popup.classList.remove('flodesk-popup--nested');

  if (!wasNested) {
    document.body.style.overflow = '';
  }
}